// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-s-flag[data-v-20e2bf3a] {\n  float: right;\n  line-height: 34px;\n}\n.ts-divider[data-v-20e2bf3a] {\n  padding: 5px 0;\n  margin-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
